import { ErrorOutline } from '@mui/icons-material';
import { Chip, Tooltip } from '@mui/material';

export type TaskNAQChipProps = {
  message: string;
};

export function TaskNAQChip({ message }: TaskNAQChipProps) {
  return (
    <Tooltip title={message} placement="top" data-testid="task-NAQ-chip">
      <Chip
        sx={{
          maxWidth: '10vw',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        color={'warning'}
        label={message}
        icon={<ErrorOutline />}
      />
    </Tooltip>
  );
}
